import { ajv } from "./ajv.js";
import { transformAjvErrors } from "./errors.js";
const validatorCache = new WeakMap();
/**
 * Create a validator function from a JSON Schema.
 * Uses WeakMap caching to avoid recompiling the same schema.
 */
export function createSchemaValidator(schema) {
    let validator = validatorCache.get(schema);
    if (!validator) {
        const validate = ajv.compile(schema);
        validator = async (values) => {
            validate(values);
            return transformAjvErrors(validate.errors);
        };
        validatorCache.set(schema, validator);
    }
    return validator;
}
/**
 * Compose multiple validators into one.
 * All validators run in parallel and errors are merged.
 */
export function composeValidators(...validators) {
    return async (values) => {
        const results = await Promise.all(validators.map((v) => v(values)));
        return Object.assign({}, ...results);
    };
}
/**
 * A no-op validator that always returns no errors.
 * Useful for disabling schema validation.
 */
export const noOpValidator = async () => ({});
